var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-tag",class:{
    'q-tag_closable': _vm.closable
  }},[_c('div',{staticClass:"q-tag__text"},[_vm._t("default")],2),(_vm.closable)?_c('button',{staticClass:"q-tag__close q-icon-close",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClose($event)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }